// SOURCE: https://github.com/j-mendez/next-intercom
/*
The MIT LICENSE (MIT)
Copyright (c) A11yWatch LLC
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import type { IIntercomProps, IntercomLoad } from "./types";

function loadScript(
  { src, initIntercomWindow, initWindow, scriptType = "async", callBack }: IntercomLoad,
  updateProps: IIntercomProps,
) {
  const intercomLoaded = document.querySelector(`script[src="${src}"]`);

  if (!intercomLoaded) {
    const intercomScript = document.createElement("script");
    intercomScript.type = "text/javascript";

    if (typeof scriptType !== "undefined") {
      intercomScript[scriptType] = true;
    }

    intercomScript.src = src;
    const scripts = document.getElementsByTagName("script");
    const initialScript = scripts?.length ? scripts[0] : null;

    if (intercomScript) {
      initialScript?.parentNode
        ? initialScript.parentNode.insertBefore(intercomScript, initialScript)
        : document.body.appendChild(intercomScript);
    }

    if (initWindow && updateProps) {
      initIntercomWindow(updateProps);
    }
  } else {
    console.error("intercom script already inserted");
  }

  typeof callBack === "function" && callBack();
}

export { loadScript };
